import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { BidderSignUpReportContainer } from "../components/reporting/BidderSignUpReportContainer";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

const BidderSignUpReporting = () => (
  <Container maxWidth={"lg"} fixed>
    <SecureArea memberPermission={MemberPermission.AccountAdmin}>
      <Typography variant="h4" color="primary" gutterBottom>
        Bidder Sign Up Reports
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Create an export for bidder sign up reports
      </Typography>
      <Box mt={4}>
        <BidderSignUpReportContainer />
      </Box>
    </SecureArea>
  </Container>
);

export default withAITracking(reactPlugin, BidderSignUpReporting, "BidderSignUpReporting");
